import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TRIGGERS_QUERY_KEY} from "../queryKeys";
import {ReachTrigger, ReachTriggerPayload} from "./types";

const createTrigger = async (payload: ReachTriggerPayload): Promise<ReachTrigger> => {
  const response = await axiosReachInstance.post<ReachTrigger, AxiosResponse<ReachTrigger>, ReachTriggerPayload>(
    "/triggers",
    payload
  );
  return response.data;
};

export const useCreateTrigger = (
  options?: BaseMutationOptions<ReachTrigger, ReachTriggerPayload>
): BaseUseMutationResult<ReachTrigger, ReachTriggerPayload> => {
  return useBaseMutation<ReachTrigger, ReachTriggerPayload>(createTrigger, {
    ...options,
    prefixKeysToReset: () => [[TRIGGERS_QUERY_KEY]],
  });
};
